import active618 from './618/index'

const GlobalModal = () => {}

/** 2024年 618 活动 */
GlobalModal.Active618 = active618

export default GlobalModal
